import { AccountType, useAppStore } from '@halo/chat-sdk-react';
import { isEmpty, take, size, eq, filter } from 'lodash/fp';
import { Box, Text } from '@chakra-ui/react';
import { SessionItem } from './SessionItem';

function RecentSessions() {
  const { t } = useTranslation();
  const { sessions } = useAppStore();

  const showSessions = useMemo(
    () =>
      take(
        5,
        filter((item) => item?.user_info?.account_type !== AccountType.Robot, sessions)
      ),
    [sessions]
  );

  if (isEmpty(showSessions)) {
    return null;
  }

  return (
    <Box>
      <Text fontSize="xs" color="fg.muted" fontWeight="medium" p="2.5">
        {t('filter.recentChats')}
      </Text>
      <Box className="List" bg="bg" p="1" borderRadius="lg">
        {showSessions?.map((item, index) => (
          <SessionItem
            key={index}
            session={{ ...item, unread_count: 0 }}
            shouldAnimate={false}
            hiddenBorder={eq(index + 1, size(showSessions))}
          />
        ))}
      </Box>
    </Box>
  );
}

export default RecentSessions;
